import { UserInfoService } from "../core/user-info-service";

export class LocalUserInfoService extends UserInfoService {
    getUserMenuUrl = () => `https://localhost:5001/api/user-info/user-menu`;
    getUserInfoUrl = () => `https://localhost:5001/api/user-info`;
}
